<template>
	<v-menu
		v-if="user"
		bottom
		min-width="300px"
		rounded
		max-width="400px"
		offset-y
		left
		:max-height="maxHeight"
		:close-on-content-click="false"
		class="ml-auto"
		v-model="show"
	>
		<template v-slot:activator="{ on }">
			<v-btn
				v-on="on"
				icon text
				elevation="0"
				plain
				class="px-0"
				width="40"
				:loading="loading"
			>
				<v-icon>$envelope</v-icon>
				<v-badge
					v-if="unreadMessagesCount"
					overlap
					bordered
					top
					offset-y="3"
					color="red"
					:content="unreadMessagesCount >= 100 ? '99+' : unreadMessagesCount"
				>
				</v-badge>
			</v-btn>
		</template>
		<v-card>
			<v-card-title class="pb-2 px-4 font-14">{{ $vuetify.lang.t('$vuetify.views.chat.messages.unreadMessages')  }}</v-card-title>
			<div >
				<chats-list
					v-if="unreadMessagesCount"
					only-list
					unread
					@openRoom="openRoom"
				/>
				<v-card-text v-else class="py-3 px-4">
					{{ $vuetify.lang.t('$vuetify.views.chat.messages.noUnreadMessages') }}
				</v-card-text>
				<v-card-text class="px-4 py-3">
					<v-btn
						:to="{name: 'Chat'}"
						@click="show = false"
						block
						color="accent">{{ $vuetify.lang.t('$vuetify.views.chat.messages.allMessages') }}</v-btn>
				</v-card-text>
			</div>
		</v-card>
	</v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import ChatsList from '@/components/chat/messenger/ChatsList';
export default {
	components: {
		ChatsList
	},
	data() {
		return {
			show: false
		}
	},
	computed: {
		...mapGetters({
			user: "auth/user",
			unreadMessagesCount: 'chat/unreadMessagesCount',
			loading: 'chat/loadingRooms'
		}),
		maxHeight() {
			if(document.body.clientHeight < 768) {
				return 'calc(100vh - 100px)';
			}
			return 768;
		},
	},
	methods: {
		openRoom(room) {
			console.log("ROOM", room)
			if(this.$route.name == 'Chat') {
				if(this.$route.params.hash != room.hash) {
					this.$router.push({name: 'Chat', params: {hash: room.hash}})
				}
			}
			else {
				this.$router.push({name: 'Chat', params: {hash: room.hash}})
			}
			this.show = false
		}
	}
};
</script>
